import React from "react";
import globalHook from "use-global-hook";
import * as actions from "./actions";

const initialState = {
  auth: null,
  user: null,
  giftidea: null,
  mygiftlist: [],
  activity: [],
  myarchive: [],
  giftlists: [],
  shoppinglist: [],
  suggesteds: [],
  activeGiftlist: {
    user: null,
    giftlist: [],
    archive: [],
  },
  giftideas: [],
  sidepanelgiftideas: [],
  response: null,
  ui: {
    menu: {
      showMobileSubmenu: false,
    },
    sidepanel: {
      state: {},
    },
    dashboard: {
      activeTab: "home",
    },
    giftlist: {
      activeTab: "giftlist",
    },
  },
};

const useGlobal = globalHook(React, initialState, actions);

export const connect = (Component) => {
  return (props) => {
    let [state, actions] = useGlobal();
    let _props = { ...props, state, actions };
    return <Component {..._props} />;
  };
};

export default useGlobal;
